import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

// Per sort: requested → sent (greige pieces) → received (pieces in FG packs) → balance.
export const OrderLinesTable = ({ order }) => (
  <Table data-testid="jw-lines-table">
    <TableHeader>
      <TableRow>
        <TableHead>Sort no</TableHead><TableHead>FG (from Sort No master)</TableHead>
        <TableHead className="text-right">Requested</TableHead><TableHead className="text-right">Sent</TableHead>
        <TableHead className="text-right">Received</TableHead><TableHead className="text-right">Balance</TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      {(order.lines || []).map((l) => {
        const bal = (l.sent_pcs || 0) - (l.received_pcs || 0);
        return (
          <TableRow key={l.sort_no} data-testid={`jw-line-row-${l.sort_no}`}>
            <TableCell className="font-mono text-xs">{l.sort_no}</TableCell>
            <TableCell>
              <p className="font-mono text-xs">{l.fg_name}</p>
              <p className="text-[11px] text-gray-500">{[l.design_name, l.shade, l.size].filter(Boolean).join(' · ')}</p>
            </TableCell>
            <TableCell className="text-right">{l.requested_pcs}</TableCell>
            <TableCell className="text-right">{l.sent_pcs || 0}<span className="text-[11px] text-gray-400"> / {l.sent_bundles || 0} bdl</span></TableCell>
            <TableCell className="text-right">{l.received_pcs || 0}<span className="text-[11px] text-gray-400"> / {l.received_packs || 0} packs</span></TableCell>
            <TableCell className={`text-right font-semibold ${bal > 0 ? 'text-amber-700' : bal < 0 ? 'text-rose-700' : 'text-emerald-700'}`}
              data-testid={`jw-line-balance-${l.sort_no}`}>
              {bal > 0 ? `${bal} short` : bal < 0 ? `${-bal} extra` : '0'}
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  </Table>
);

export default OrderLinesTable;
